import React from "react";
import "../css/policy.css";


const Terms = () => {
  return (
    <div className="terms-container">
      <h1>Terms and Conditions</h1>
      <p>By placing an order with H&H Fashion via WhatsApp, you agree to the following terms and conditions:</p>
      <section>
        <h2>1. Orders</h2>
         <ul>
          <li>Orders are confirmed only after full payment is received (No Cash on Delivery).</li>
          <li>Once confirmed, orders cannot be cancelled.</li>
          <li>Product availability is subject to stock at the time of confirmation.</li>
        </ul>
      </section>

      <section>
        <h2>2. Pricing</h2>
        <ul>
          <li>All prices are mentioned in INR (₹).</li>
          <li>Prices are subject to change without prior notice.</li>
          <li> Any applicable shipping charges will be communicated before order confirmation.</li>
        </ul>
      </section>

      <section>
        <h2>3. Payments</h2>
         <ul>
          <li>Accepted payment modes: UPI / Bank Transfer / Wallets.</li>
          <li>We are not responsible for payment failures due to third-party platforms.</li>
        </ul>
      </section>

      <section>
        <h2>4. Shopping and Delivery</h2>
         <ul>
          <li>Orders are shipped within 2 working days after confirmation.</li>
          <li>Delivery timelines may vary based on location and courier service.</li>
          <li>Delays caused by courier partners, weather, or unforeseen events are beyond our control.</li>
        </ul>
      </section>

      <section>
        <h2>5. Returns and Exchange</h2>
         <ul>
          <li>Returns/exchanges are accepted only for damaged, defective, or wrong items received.</li>
          <li>An unboxing video is mandatory for return/exchange requests.</li>
          <li>Requests must be raised within 24 hours of delivery.</li>
          <li>No returns/exchanges on discounted or clearance items.</li>
        </ul>
      </section>

      <section>
        <h2>6. Products colors and Exchange</h2>
         <ul>
          <li>Actual product color may slightly vary due to lighting and screen resolution.</li>
          <li>Size charts are provided for reference—please check carefully before ordering.</li>
        </ul>
      </section>

      <section>
        <h2>7. Refunds</h2>
        <ul>
          <li>Approved refunds will be processed within [5–10] working days to the original payment method.</li>
          <li>Shipping charges are non-refundable.</li>
        </ul>
      </section>

      <section>
        <h2>8. Communication</h2>
        <ul>
          <li>All order-related communication will be done via WhatsApp only.</li>
          <li>Please ensure your contact details are accurate.</li>
        </ul>
      </section>

      <section>
        <h2>9. Intellectual Property</h2>
         <ul>
          <li>All images, designs, logos, and content belong to H&H Fashion and may not be used without permission.</li>
        </ul>
      </section>

      <section>
        <h2>10. policy Updates</h2>
         <ul>
          <li>H&H Fashion reserves the right to modify these terms at any time without prior notice.</li>
        </ul>
      </section>
      
    </div>
  );
};

export default Terms;
